import React from 'react';
import { errorsWithEntities } from '@/utils/errors';
import ErrorMessages from '@/components/errors/ErrorMessages';
import { systemCohortReadError } from '../helper';

const CohortErrorMessages = ({
  category,
  code,
  entities,
  isSystemCohort,
  saveErrors,
  updateProperties,
  validationErrors = [],
}) => {
  const filteredErrors = saveErrors ? errorsWithEntities(saveErrors, entities) : [];
  const readErrors = filteredErrors.length === 0 && validationErrors.length > 0;
  if (readErrors) { filteredErrors.push(systemCohortReadError(validationErrors, isSystemCohort)); }

  return (
    <ErrorMessages
      category={category}
      code={code}
      contexts={['dictionaryUUID', 'fieldUUID']}
      entity="cohort"
      errors={filteredErrors}
      onDismiss={readErrors ? undefined : (errors) => updateProperties(category, code, { saveErrors: errors })}
    />
  );
};

export default CohortErrorMessages;
